import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GameInfo } from 'api/game';

export interface CollectionQuestion {
  id: string;
  prevItemId: string | null;
  nextItemId: string | null;
  question: {
    content: string;
    answers: Array<{
      id: string;
      answer: string;
      point: number;
      isRevealed?: boolean;
    }>;
  };
}

export interface CollectionData {
  name: string;
  questions: Array<CollectionQuestion>;
}

interface GameSlice {
  collectionData: CollectionData | null;
  game: GameInfo | null;
  gameRoom: { isStart: number; id?: number };
  index: number;
  currentUserId?: string;
  showGameNotes: boolean;
  teamsLoading: boolean;
}

const initialState: GameSlice = {
  game: null,
  gameRoom: { isStart: 0 },
  index: -1,
  showGameNotes: true,
  collectionData: null,
  teamsLoading: false,
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setGameSlice: (state, action: PayloadAction<Partial<GameSlice>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    finishHostsAssignment: (state) => {
      state.game.isHostsAssigned = true;
    },
    openTeamsLoading: (state) => {
      state.teamsLoading = true;
    },
    closeTeamsLoading: (state) => {
      state.teamsLoading = false;
    },
    closeGameNotes: (state) => {
      state.showGameNotes = false;
    },
    updateGameInfo: (state, action: PayloadAction<Partial<GameInfo>>) => {
      if (state.game) {
        state.game = {
          ...state.game,
          ...action.payload,
        };
      }
    },
    updateStoreGameEndStatus: (state, action: PayloadAction<number>) => {
      if (state.game) {
        state.game = {
          ...state.game,
          statusEnd: action.payload,
        };
      }
    },
    setIsBreakoutPopup: (state) => {
      if (state.game) {
        state.game.isBreakoutPopup = 1;
      }
    },
    toggleCollectionQuestionAnswer: (
      state,
      {
        payload: { questionIndex, index },
      }: { payload: { questionIndex: number; index: number } },
    ) => {
      if (
        state.collectionData.questions[questionIndex]?.question.answers[index]
      ) {
        state.collectionData.questions[questionIndex].question.answers[
          index
        ].isRevealed =
          !state.collectionData.questions[questionIndex]?.question.answers[
            index
          ].isRevealed;
      }
    },
    resetGame: () => {
      return initialState;
    },
  },
});
export const {
  setGameSlice,
  finishHostsAssignment,
  openTeamsLoading,
  closeTeamsLoading,
  updateGameInfo,
  updateStoreGameEndStatus,
  setIsBreakoutPopup,
  closeGameNotes,
  toggleCollectionQuestionAnswer,
} = gameSlice.actions;

export const gameReducer = gameSlice.reducer;
